<template>
    <div class="container">
        <div class="headbar">
            <div class="title">专属用药指导</div>
            <div class="back" @click="$router.back()">
                <van-icon name="arrow-left" />
            </div>
        </div>
        <div class="tabs">
            <van-tabs v-model="langs.active" type="card" color="#5585f5">
                <van-tab :title="item.text" :name="item.value" v-for="(item, index) in langs.list"
                    :key="index"></van-tab>
            </van-tabs>
        </div>
        <div class="advices">
            <div class="scrollbar">
                <div class="prints" ref="PrintRef">
                    <template v-for="item in advices.list">
                        <div class="advice" :class="{ langs: langs.active !== 'zh_CN', bo: langs.active === 'bo_CN' }">
                            <div class="header">
                                <!-- <van-image :src="HeaderImg" /> -->
                            </div>
                            <div class="titlebar">
                                <span>{{ item.userMemberName }}</span>
                                <span>-专属用药指导</span>
                            </div>
                            <div class="timebar">
                                <div class="zh" v-if="langs.active === 'zh_CN'">（{{ item.time }}处方）</div>
                                <div v-else-if="langs.values[langs.active]">
                                    <span class="zh">{{ item.userMemberName }}-</span>
                                    <span class="trans">{{ langs.values[langs.active].title }}</span>
                                </div>
                            </div>
                            <div class="drugs">
                                <div class="table">
                                    <div class="tr thead">
                                        <div class="td">
                                            <div class="p">最佳用药时段</div>
                                            <div class="p"
                                                v-if="langs.values[langs.active] && langs.values[langs.active].thead.timeName">
                                                {{ langs.values[langs.active] &&
                langs.values[langs.active].thead.timeName }}
                                            </div>
                                        </div>
                                        <div class="td">
                                            <div class="p">服用药品</div>
                                            <div class="p"
                                                v-if="langs.values[langs.active] && langs.values[langs.active].thead.medicationName">
                                                {{ langs.values[langs.active] &&
                langs.values[langs.active].thead.medicationName }}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tr" v-for="(group, groupIndex) in item.groups" :key="groupIndex">
                                        <div class="td">
                                            <div class="p">{{ group.label }}</div>
                                            <div class="p" v-if="langs.values[langs.active] &&
                langs.values[langs.active].thead[group.type]
                ">
                                                {{
                langs.values[langs.active].thead[group.type]
            }}
                                            </div>
                                            <div class="p time">{{ group.time }}</div>
                                        </div>
                                        <div class="td">
                                            <div class="cells">
                                                <div class="cell" v-for="(drug, drugIndex) in group.drugs"
                                                    :key="drugIndex">
                                                    <span>{{ drug.drugName }}</span>
                                                    <span>&nbsp;&nbsp;</span>
                                                    <span>口服</span>
                                                    <span>&nbsp;&nbsp;</span>
                                                    <span class="red">{{ drug.dosage }}</span>
                                                    <span class="red">
                                                        {{ drug.dosageUnitName }}
                                                    </span>
                                                    <template v-if="!drug.frequencyName.includes('每日')">
                                                        <span>&nbsp;</span>
                                                        <span class="orange">({{ drug.frequencyName }})</span>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tips">
                                <div class="head">
                                    <span class="zh">医生温馨提示</span>
<!--                                    <span class="trans" v-if="langs.values[langs.active]">-->
<!--                                        {{ langs.values[langs.active].prompts.title }}-->
<!--                                    </span>-->
                                    <span>：</span>
                                </div>
                                <div class="prompts">
                                    <div class="item" v-for="(itm, idx) in advices.prompts" :key="idx">
                                        <div class="label">{{ idx + 1 }}.</div>
                                        <div class="value">
                                            <div class="zh">
                                                {{ itm }}{{ idx >= advices.prompts.length - 1 ? '。' : '；' }}
                                            </div>
                                            <div class="trans" v-if="langs.values[langs.active]">
                                                {{ langs.values[langs.active].prompts[`p${idx + 1}`] }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="list">
                                    <div class="item" v-for="(itm, idx) in advices.tips" :key="idx">
                                        <div class="label">
                                            <div class="label-box">
                                                <div class="zh">{{ itm.label }}</div>
                                                <div class="trans" v-if="langs.values[langs.active]">
                                                    {{ langs.values[langs.active].advices[itm.type].title }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="content">
                                            <div class="content-box">
                                                <div class="zh">{{ itm.content }}</div>
                                                <div class="trans" v-if="langs.values[langs.active]">
                                                    {{ langs.values[langs.active].advices[itm.type].content }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="concats">
                                <template v-if="langs.active === 'zh_CN'">
                                    <div class="info">
                                        <div class="item">
                                            <div class="text">联系热线：400-154-1313</div>
                                        </div>
                                        <div class="item">
                                            <!-- <div class="text">医院地址:成都市武侯区洗面桥街8号(地铁3号线-衣冠庙站-C口步行80m即达)</div> -->
                                        </div>
                                        <div class="foot">
                                            <!-- <van-image :src="LogoImg" /> -->
                                        </div>
                                    </div>
                                    <div class="qrcodes">
                                        <!-- <div class="img">
                                            <van-image :src="QrcodeImg" />
                                        </div>
                                        <div class="text">
                                            <div class="p">扫码进入润生医荃宜互联网医院</div>
                                            <div class="p">免费专业健康咨询</div>
                                        </div> -->
                                    </div>
                                </template>
                                <div class="logo" v-else>
                                    <!-- <div class="img">
                                        <van-image :src="LogoBlackImg" />
                                    </div>
                                    <div class="text">身心兼治·病愈得悟·乐享健康</div> -->
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="footbar" v-if="advices.list.length">
            <div class="link" @click="onCopyImg">复制图片</div>
        </div>

        <!-- 图片预览 -->
        <van-dialog v-model="previews.show" cancelButtonText="返回" showCancelButton :showConfirmButton="false">
            <div class="scroll" style="max-height: 70vh; overflow-y: auto">
                <van-image :src="previews.img" />
            </div>
        </van-dialog>
    </div>
</template>
<script>
import { formatTime } from '@/hooks/function'
import { fileBase64ToFile } from '@/hooks/file'
import api from '@/utils/request'
import QrcodeImg from '@/assets/images/advice/print/qrcode.png'
import LogoImg from '@/assets/images/advice/print/logo.png'
import LogoBlackImg from '@/assets/images/advice/print/logo-black.png'
// import HeaderImg from '@/assets/images/advice/print/header.png'
import DrugImg from '@/assets/images/advice/print/drug.png'
import DrugLightImg from '@/assets/images/advice/print/drug-light.png'
import TimeImg from '@/assets/images/advice/print/time.png'
import TimeOImg from '@/assets/images/advice/print/time-o.png'
import Html2canvas from 'html2canvas'
export default {
    components: {},
    data() {
        return {
            QrcodeImg,
            LogoImg,
            LogoBlackImg,
            // HeaderImg,
            DrugImg,
            DrugLightImg,
            TimeImg,
            TimeOImg,
            advices: {
                show: false,
                loading: false,
                tips: [
                    {
                        type: 'diet',
                        label: '饮食',
                        content: '在服药期间适当注意饮食起居的配合，如饮食清淡营养，戒烟限酒，忌辛辣煎炸、刺激性大、油腻及胶原蛋白含量高的食物，不要喝碳酸饮料，少吃酸性水果，多吃蔬菜等。'
                    },
                    {
                        type: 'rest',
                        label: '起居',
                        content: '按时休息、保证充足睡眠，晚上尽量在23点以前 入睡、避免受寒、受凉、过度劳累、适当按摩四肢增加血液循环。'
                    },
                    {
                        type: 'emotional',
                        label: '情志',
                        content: '避免情绪激动,可以听轻音乐、冥想、品茶、工作之余也可以适当的运动20-30分钟，散散步,跟朋友聊聊天。'
                    }
                ],
                prompts: [
                    '服药时间为饭前半小时',
                    '可根据个人作息时间可以适当做调整，如有胃肠不适可以改为饭后半小时服用',
                    '药丸请嚼碎或者捣碎服用'
                ],
                list: []
            },
            times: [
                {
                    type: 'early',
                    label: '早饭前',
                    time: '(07:00 - 08:00)',
                    value: ['早', '饭前'],
                    drugs: []
                },
                {
                    type: 'earlyAfter',
                    label: '早饭后',
                    time: '(08:00 - 09:00)',
                    value: ['早', '饭后'],
                    drugs: []
                },
                {
                    type: 'noon',
                    label: '午饭前',
                    time: '(11:30 - 12:30)',
                    value: ['午', '饭前'],
                    drugs: []
                },
                {
                    type: 'noonAfter',
                    label: '午饭后',
                    time: '(12:30 - 13:30)',
                    value: ['午', '饭后'],
                    drugs: []
                },
                {
                    type: 'night',
                    label: '晚饭前',
                    time: '(17:30 - 18:30)',
                    value: ['晚', '饭前'],
                    drugs: []
                },
                {
                    type: 'nightAfter',
                    label: '晚饭后',
                    time: '(18:30 - 19:30)',
                    value: ['晚', '饭后'],
                    drugs: []
                },
                {
                    type: 'bedtime',
                    label: '睡前',
                    time: '(21:00 - 22:00)',
                    value: ['睡'],
                    drugs: []
                }
            ],
            previews: {
                show: false,
                img: ''
            },
            langs: {
                active: 'zh_CN',
                list: [
                    {
                        text: '中文版',
                        value: 'zh_CN'
                    },
                    {
                        text: '中藏文版',
                        value: 'bo_CN'
                    },
                    {
                        text: '中英文版',
                        value: 'en_CN'
                    }
                ],
                values: {
                    bo_CN: {
                        title: 'ཆེད་གཏོགས་སྨན་སྤྱོད་མཛུབ་སྟོན།',
                        thead: {
                            timeName: 'སྨན་བསྟེན་ཚོད།',
                            medicationName: 'སྨན་སྣ།',
                            early: 'ཞོགས་ཟས་སྔོན།',
                            noon: 'ཉིན་གུང་ཟས་སྔོན།',
                            night: 'དགོང་ཇ་སྔོན།',
                            earlyAfter: 'ཞོགས་ཟས་རྗེས།',
                            noonAfter: 'ཉིན་གུང་ཟས་རྗེས།',
                            nightAfter: 'དགོང་ཇ་ཟས་རྗེས།',
                            bedtime: 'མལ་ཁར།'
                        },
                        prompts: {
                            title: 'གསལ་འདེབས།',
                            p1: 'སྨན་བསྟེན་པའི་དུས་ཚོད་ནི་ཟ་མ་མ་ཟོས་སྔོན་གྱི་དུས་ཚོད་ཕྱེད་ཀ་ཡིན།',
                            p2: 'མི་སྒེར་གྱི་ངལ་གསོའི་དུས་ཚོད་ལ་གཞིགས་ནས་ལེགས་སྒྲིག་འོས་འཚམ་བྱས་ཆོག ཟས་སྔོན་སྨན་བསྟེན་རྗེས་མི་འཕྲོད་པ་ཡོད་ན་ཟས་རྗེས་བསྟེན་ཆོག ་',
                            p3: 'སྨན་རིལ་ལྡད་པའམ་ཡང་ན་ཁྲོལ་རྡུངས་བྱས་ནས་བསྟེན་དགོས། །'
                        },
                        advices: {
                            diet: {
                                title: 'ཟས་རིགས།',
                                content:
                                    'སྨན་བསྟེན་སྐབས་ཟས་སྤྱོད་ལ་དོ་སྣང་བྱེད་དགོས། དཔེར་ན་ཟས་མ་ཚོས་ཚིག་དང་ཁེངས་བོ་རྗེན་པ་དང་རུལ་སྐྱུར་སོགས་མི་འཕྲོད་པའི་ཟས་རིགས་སྤང་སྟེ་ཟས་འཇུ་སླ་བའི་རིགས་བསྟེན་དགོས།ཐ་མག་དང་ཆང་ལ་ཚོད་འཛིན་བྱེད་དགོས། '
                            },
                            rest: {
                                title: 'འགྲོ་འདུག',
                                content:
                                    'དགོང་མོར་དུས་ལྟར་ངལ་གསོ་བྱ་བ་དང་།རྩོལ་བཅག་རན་པར་བསྟེན་པ། ཡན་ལག་དང་གསང་དམིག་ལ་འཕུར་མཉེད་བྱེད་པ་སོགས།'
                            },
                            emotional: {
                                title: 'སེམས་ཁམས།',
                                content:
                                    'སེམས་ཁམས་སྙོམས་སྒྲིག་བྱ་བ་སྟེ།དཔེར་ན་གླུ་དབྱངས་ལ་ཉན་པ་དང་བསམ་བློ་གཏོང་བ།ཇ་འཐུང་བ།ངལ་གསོ་འོས་འཚམ་བྱ་བ།རྩོལ་བཅག་རན་པར་བསྟེན་པ། ཡིད་དུ་འོང་བའི་གྲོགས་དང་བསྟེན་པ་སོགས། '
                            }
                        }
                    },
                    en_CN: {
                        title: 'Exclusive Medication Guidance',
                        thead: {
                            timeName: 'Best time to take',
                            medicationName: 'Medication',
                            early: 'Before breakfast',
                            noon: 'Before lunch',
                            night: 'Before dinner',
                            earlyAfter: 'After breakfast',
                            noonAfter: 'After lunch',
                            nightAfter: 'After dinner',
                            bedtime: 'Before bedtime'
                        },
                        prompts: {
                            title: ``,
                            p1: 'Take medication half an hour before meals.',
                            p2: 'You can adjust the timing according to your personal schedule. If you experience gastrointestinal discomfort,you can take the medication half an hour after meals.',
                            p3: 'Please chew or crush the pills before taking them.'
                        },
                        advices: {
                            diet: {
                                title: 'Diet',
                                content:
                                    'During the medication period, it is important to pay attention to diet and lifestyle, such as consuming a light and nutritious diet, quitting smoking and limiting alcohol intake, avoiding spicy, fried, and greasy foods, as well as foods high in collagen content. Avoid carbonated drinks, reduce consumption of acidic fruits, and increase intake of vegetables.'
                            },
                            rest: {
                                title: 'Rest',
                                content:
                                    'Rest on time and ensure an adequate amount of sleep. Try to go to bed before 11 p.m. to avoid getting cold, overexertion, or excessive fatigue. Engage in gentle limb massages to enhance blood circulation.'
                            },
                            emotional: {
                                title: 'Emotional  State',
                                content:
                                    'Avoid getting emotionally excited. You can listen to soft music, meditate, drink tea, and engage in light exercise for 20-30 minutes during breaks from work. Taking a walk and chatting with friends are also beneficial.'
                            }
                        }
                    }
                }
            }
        }
    },
    mounted() {
        this.init(this.$route.query.askNo)
    },
    methods: {
        async init(askNo) {
            if (!askNo) return false
            this.advices.loading = true
            try {
                const data = await this.onDataGet(askNo)
                this.advices.list = [this.onDrugGroup(data)]
            } catch (error) {
                console.error(error)
            }
            this.advices.loading = false
        },
        async onDataGet(askNo) {
            const { data, code } = await api({
                method: 'get',
                url: '/doctor-service/prescription/getAskPrescription',
                params: {
                    askNo
                }
            })
            if (code === 0) {
                return data
            } else {
                throw false
            }
        },
        // 药品初始化
        onDrugInit(list) {
            const timesArr = JSON.parse(JSON.stringify(this.times))
            for (let i = 0; i < list.length; i++) {
                const item = list[i]
                timesArr.forEach((row) => {
                    if (row.value.every((value) => item.drugUsageName.includes(value))) {
                        row.drugs.push(JSON.parse(JSON.stringify(item)))
                    }
                });
            }
            return timesArr
        },
        // 分组
        onDrugGroup(row) {
            const times = this.onDrugInit(row.prescriptionList)
            return {
                userMemberName: row.memberName,
                time: formatTime(row.createTime).format('M月D日'),
                groups: times.filter((row) => row.drugs.length)
            }
        },
        async onCopyImg() {
            const base64 = await this.onCanvasCreate()
            try {
                const file = await fileBase64ToFile(base64, '用药指导')
                await navigator.clipboard.write([
                    new ClipboardItem({
                        [file.type]: file,
                    }),
                ]);
                this.$toast.success("复制成功");
            } catch (error) {
                this.$toast('请长按图片进行分享')
                this.previews.img = base64
                this.previews.show = true
            }
        },
        async onCanvasCreate() {
            const canvas = await Html2canvas(this.$refs.PrintRef, {
                scale: 2
            })
            return canvas.toDataURL('image/png')
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/base";
$mainColor: #2f4593;

.container {
    height: 100vh;
    display: flex;
    flex-direction: column;
    background: #fff;
    font-size: 14px;
}

.headbar {
    position: relative;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #eee;

    .title {
        font-weight: bold;
        font-size: 20px;
    }

    .back {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        .van-icon {
            font-size: 24px;
        }
    }
}

.tabs {
    padding: 10px 0;
    border-bottom: 1px solid #eee;
}

.advices {
    flex: 1;
    overflow-y: auto;

    .scrollbar {
        .prints {
            padding: 20px;
        }
    }

    .advice {
        padding-bottom: 10px;
        page-break-after: always;
        word-break: break-word;
        word-wrap: break-word;

        &:not(:first-child) {
            margin-top: 20px;
        }

        .titlebar {
            text-align: center;
            font-weight: bold;
            font-size: 22px;
            padding-top: 10px;
            color: #303030;
        }

        .timebar {
            padding-top: 5px;
            color: $mainColor;
            font-weight: bold;
            font-size: 18px;
            text-align: center;
        }

        .drugs {
            padding-top: 15px;

            .table {
                display: table;
                table-layout: fixed;
                border: 1px solid #474443;
                width: 100%;
                border-collapse: collapse;
                margin-top: 7px;
                font-size: 12px;
                box-sizing: border-box;

                .tr {
                    display: table-row;

                    .td {
                        display: table-cell;
                        border: 1px solid #536ab6;
                        padding: 7px;
                        vertical-align: middle;
                        font-size: 14px;

                        &:first-child {
                            width: 35%;
                            text-align: center;
                        }
                    }

                    &:nth-child(odd) {
                        .td {
                            background: #e9efff;
                        }
                    }

                    &.thead {
                        .td {
                            background: $mainColor;
                            text-align: center;
                            color: #fff;
                            font-weight: bold;
                            padding: 15px;
                            font-size: 16px;
                        }
                    }

                    .cells {
                        font-weight: bold;

                        .cell {
                            &:not(:first-child) {
                                margin-top: 4px;
                            }

                            .red {
                                color: #f43126;
                            }
                            .orange {
                                color: #ff3800;
								font-size: 12px;
                            }
                        }
                    }

                    .time {
                        font-weight: bold;
                        margin-top: 4px;
                    }
                }
            }
        }

        .tips {
            margin-top: 15px;

            .head {
                font-weight: bold;
                color: #333;
                font-size: 16px;
            }

            .prompts {
                background: #e9efff;
                padding: 10px;
                margin-top: 8px;
                color: $mainColor;
                font-weight: bold;
                font-size: 14px;
                border-radius: 4px;

                .item {
                    display: flex;

                    .label {
                        white-space: nowrap;
                    }
                }
            }

            .list {
                padding-top: 20px;

                .item {
                    display: flex;
                    align-items: stretch;

                    &:not(:first-child) {
                        margin-top: 15px;
                    }

                    .label {
                        position: relative;
                        flex: none;
                        background: #f60;
                        width: 70px;
                        font-weight: bold;
                        color: #775d2b;
                        background: #f5d495;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 4px;
                        font-size: 16px;
                        text-align: center;

                        &::after {
                            content: '';
                            position: absolute;
                            right: -6px;
                            top: 50%;
                            width: 0;
                            height: 0;
                            border: 6px solid transparent;
                            border-left-color: #f5d495;
                            border-right-width: 0;
                            margin-top: -3px;
                        }
                    }

                    .content {
                        flex: 1;
                        margin-left: 10px;
                        min-height: 60px;
                        display: flex;
                        align-items: center;
                        background: #fdf4e4;
                        padding: 5px 10px;
                        border-radius: 4px;
                        font-weight: bold;
                        color: #333;
                        font-size: 14px;
                    }
                }
            }
        }

        .concats {
            display: flex;
            justify-content: space-between;
            margin-top: 50px;

            .info {
                font-size: 12px;

                .item {
                    display: flex;
                    align-items: center;
                    font-weight: bold;
                    color: #333;
                    font-size: 13px;

                    &:not(:first-child) {
                        margin-top: 3px;
                    }
                }

                .foot {
                    margin-top: 15px;
                    height: 30px;

                    .van-image {
                        width: auto;
                        height: 30px;

                        :deep(img) {
                            width: auto;
                        }
                    }
                }
            }

            .qrcodes {
                flex: none;
                margin-left: 20px;

                .img {
                    width: 60px;
                    height: 60px;
                    margin: 0 auto;
                }

                .text {
                    text-align: center;
                    font-size: 10px;
                    font-weight: bold;
                    color: #333;
                }
            }

            .logo {
                font-weight: bold;
                line-height: 1.2;
                color: $mainColor;
                font-size: 12px;

                .van-image {
                    height: 12px;
                }

                .text {
                    margin-top: 2px;
                }
            }
        }

        &.langs {
            --font-size-normal: 12px;

            &.bo {
                --font-size-normal: 16px;
            }

            .timebar {
                color: #333;
            }

            .tips {
                .trans {
                    font-size: var(--font-size-normal);
                }

                .prompts {

                    .item {
                        line-height: 1.3;
                        color: #333;

                        &:not(:first-child) {
                            margin-top: 10px;
                        }
                    }
                }
            }
        }
    }

    .footer {
        margin-top: 20px;
        text-align: center;
    }
}

.footbar {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;

    .link {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        background: #4187f7;
        color: #fff;
        height: 45px;
        padding: 0 80px;
        border-radius: 50px;
        cursor: pointer;

        &:active {
            opacity: 0.85;
        }
    }
}
</style>